export function UnderwriterConsentCheckout() {
    return (
        <>
            <p>
                As a condition of this insurance, you agree to obtain or release all medical records to PTZ Insurance Services Ltd. upon enrollment. If no medical records exist for
                your pet, or your pet has not been to a veterinarian within the past six (6) months, you agree to have your pet undergo a complete physical examination by a
                licensed veterinarian, at your cost, within thirty (30) days of your policy effective date. You then will forward those examination notes to us. You agree to
                authorize us to obtain any and all medical records for your pet as needed for the processing and support of your policy and claim files.
            </p>
            <p>
                You declare that the particulars stated in this application are true and no material fact has been withheld. You understand that misrepresentation or non-disclosure
                may void the contract. You understand that the completion of this application form does not guarantee insurance coverage.
            </p>
            <p>
                <span className="font-bold">Toll-Free Fax:</span> 1-866-369-7387 <br />
                Email: medicals@spotpetinsurance.ca <br />
                Mail to: <br />
                Spot Pet Insurance Programs C/O PTZ Insurance Services Ltd. 710 Dorval Dr. Suite 400 <br />
                Oakville, ON L6K 3V7
            </p>
            <p>
                Acceptance of Policy Terms and Conditions & Underwriting Requirements constitutes your authorization for PTZ Insurance Services Ltd. to continue collecting your
                monthly premium via existing payment methods unless you notify us in writing to the contrary.
            </p>
        </>
    );
}
